module.exports = __webpack_public_path__ + "static/img/m_role.af254e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/oo/m_role.png
// module id = Dx1w
// module chunks = 7